/**
 * Close Search Action
 * Triggered by: arc:action:searchClose
 *
 * Adds or removes the 'opensearch-active' class on <body> when toggled on/off.
 * Usage: window.dispatchEvent(new CustomEvent('arc:action:searchClose', { detail: { open: true } }))
 */

export const runSearchClose = async (data = {}) => {
  try {
    const { open } = data;

    window.dispatchEvent(
      new CustomEvent('close-search', {
        detail: {}
      })
    );
    return {
      success: true,
      open
    };
  } catch (error) {
    console.error('runSearchClose error:', error);
    return {
      success: false,
      error: error.message
    };
  }
};

export default runSearchClose;
